
export default {
  name: 'IconETerminal',
}
